 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CHIPRAGER0001 from '@/components/chi-prager-0001'
 import CHIPRAGER0002 from '@/components/chi-prager-0002'
 import CHIPRAGER0003 from '@/components/chi-prager-0003'
 import CHIPRAGER0004 from '@/components/chi-prager-0004'
 import CHIPRAGER0005 from '@/components/chi-prager-0005'
 import CHIPRAGER0006 from '@/components/chi-prager-0006'
 import CHIPRAGER0007 from '@/components/chi-prager-0007'
 import CHIPRAGER0008 from '@/components/chi-prager-0008'
 import CHIPRAGER0009 from '@/components/chi-prager-0009'
 import CHIPRAGER0010 from '@/components/chi-prager-0010'
 import CHIPRAGER0011 from '@/components/chi-prager-0011'
 import CHIPRAGER0012 from '@/components/chi-prager-0012'
 import CHIPRAGER0013 from '@/components/chi-prager-0013'
 import CHIPRAGER0014 from '@/components/chi-prager-0014'
 import CHIPRAGER0015 from '@/components/chi-prager-0015'
 import CHIPRAGER0016 from '@/components/chi-prager-0016'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/chi-prager-0001",
 			"name" : "chi-prager-0001",
 			"component" : CHIPRAGER0001
 		},
 		{
 			"path" : "/chi-prager-0002",
 			"name" : "chi-prager-0002",
 			"component" : CHIPRAGER0002
 		},
 		{
 			"path" : "/chi-prager-0003",
 			"name" : "chi-prager-0003",
 			"component" : CHIPRAGER0003
 		},
 		{
 			"path" : "/chi-prager-0004",
 			"name" : "chi-prager-0004",
 			"component" : CHIPRAGER0004
 		},
 		{
 			"path" : "/chi-prager-0005",
 			"name" : "chi-prager-0005",
 			"component" : CHIPRAGER0005
 		},
 		{
 			"path" : "/chi-prager-0006",
 			"name" : "chi-prager-0006",
 			"component" : CHIPRAGER0006
 		},
 		{
 			"path" : "/chi-prager-0007",
 			"name" : "chi-prager-0007",
 			"component" : CHIPRAGER0007
 		},
 		{
 			"path" : "/chi-prager-0008",
 			"name" : "chi-prager-0008",
 			"component" : CHIPRAGER0008
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js